const fetch = require('node-fetch');
import {baseApiPath} from '@/constants.js';

export default {
  getRoadsByTown: async (town) => {

    let apiUrl = `${baseApiPath}/towns/${town}/roads`;

    try {
      const response = await fetch(apiUrl);
      const json = await response.json();
      return json;
    } catch (error) {
      //console.log(error);
    }

    return;
  },
  getRoadDetail: async (town, roadName) => {
    let apiUrl = `${baseApiPath}/towns/${town}/roads/${roadName}`;

    try {
      const response = await fetch(apiUrl);
      const json = await response.json();
      return json;
    } catch (error) {
      //console.log(error);
    }

    return;
  },
  getRandomRoad: async () => {
    let apiUrl = `${baseApiPath}/randomroad`;

    try {
      const response = await fetch(apiUrl);
      const json = await response.json();
      return json;
    } catch (error) {
      //console.log(error);
    }

    return;
  }
}